/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S2_HeadingInputs */

const tr_servis_s2_heading = /** @type {(inputs: Servis_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Abonelik Planları ve Faturalandırma`)
};

const en_servis_s2_heading = /** @type {(inputs: Servis_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Subscription Plans and Billing`)
};

const de_servis_s2_heading = /** @type {(inputs: Servis_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Abonnementpläne und Rechnungsstellung`)
};

const ru_servis_s2_heading = /** @type {(inputs: Servis_S2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Тарифные планы и выставление счетов`)
};

/**
* | output |
* | --- |
* | "2. Subscription Plans and Billing" |
*
* @param {Servis_S2_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s2_heading = /** @type {((inputs?: Servis_S2_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S2_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s2_heading(inputs)
	if (locale === "de") return de_servis_s2_heading(inputs)
	if (locale === "ru") return ru_servis_s2_heading(inputs)
	return tr_servis_s2_heading(inputs)
});